import { VehicleHistoryEvent } from './vehicle-history-event';
import moment from 'moment';

export class MissedAtStopEvent extends VehicleHistoryEvent {
    public type = 'MissedAtStopEvent';

    plannedArrival?: Date;
    plannedDeparture?: Date;

    // Comes from the MetaData
    trafficDate: Date;
    vehicleTaskNumber: string;
    sequenceNumber: number;
    isLastOnActivity: boolean;
    activityType: string;
    tripNumber: string;
    activityStartTime: string;
    routeName: string;
    routePublicName: string;
    placeId: string;
    nextPlaceId: string;
    isMeasurementStop: boolean;
    isTimingPoint: boolean;
    isLastInVehicleActivity: boolean;

    constructor(obj = null) {
        super();

        if (obj) {
            this.ts = obj.ts;
        }

        if (obj?.missedActivityPoint) {
            if (obj?.missedActivityPoint?.plannedArrival) {
                this.plannedArrival = moment(obj?.missedActivityPoint.plannedArrival).toDate();
            }

            if (obj?.missedActivityPoint?.plannedDeparture) {
                this.plannedDeparture = moment(obj?.missedActivityPoint.plannedDeparture).toDate();
            }

            if (obj?.missedActivityPoint?.metadata) {
                Object.assign(this, obj?.missedActivityPoint?.metadata);
            }
        }

        if (this?.trafficDate) {
            this.trafficDate = moment(this.trafficDate).toDate();
        }
    }
}

